export default __webpack_public_path__ + "static/media/1_nearshorit-image.98bcef41.jpg";